import React, { useContext } from "react";
import style from "../../Vote/index.module.scss";
import { Spin } from "antd";
import CustomEmpty from "../../../../components/CustomEmpty";
import useRequest from "../../../../Utils/useRequest";
import { BusinessKey, findDiscussList } from "../../../../API/discuss";
import { CourseContext } from "../../Store";
import useBatchPicker from "../../../main/utils/useBatchPicker";
import ListItem from "../Components/ListItem";
import useModalHandler from "../../../../Utils/v3/useModalHandler";
import SetNoticeModal from "../../../AskTeacher/Components/SetNoticeModal";

const Index = () => {
    const { batch } = useBatchPicker();
    const {
        course: { courseNo, weekTimeId, courseSeq },
        basename
    } = useContext(CourseContext);
    const [data, { loading }, reload] = useRequest(
        () =>
            findDiscussList({
                courseNo,
                batchNo: batch!,
                courseSeq,
                weektimeId: weekTimeId
            }),
        {},
        [basename]
    );

    const setModal = useModalHandler({
        component: SetNoticeModal
    });

    function openModal() {
        setModal.open({
            businessKey: BusinessKey.Discuss,
            onSuccess: () => setModal.close()
        });
    }

    return (
        <div className={style.root}>
            <div className={style.header}>
                <div className={style.count}>
                    主题讨论（{data?.length || 0}）
                </div>
                {/*<Button type="link" icon="setting" onClick={openModal}>*/}
                {/*    设置*/}
                {/*</Button>*/}
            </div>

            <Spin spinning={loading}>
                {data?.map(item => (
                    <ListItem key={item.uuid} data={item} />
                ))}
                {!data?.length && (
                    <CustomEmpty style={{ padding: "100px 0" }} />
                )}
            </Spin>

            {setModal.render()}
        </div>
    );
};

export default Index;
